import React from 'react'
import { IonText } from '@ionic/react'
import Page from './modules/common/components/Page'
import strings from './strings'
import './less/404.less'

const Page404: React.FC = () => (
	<Page contentProps={{ className: 'page-404' }} dataCy="page-404">
		<IonText style={{ textAlign: 'center', padding: '1rem', color: 'var(--body-color)' }}>
			<i className="fal fa-signs-post" />
			<h1>{strings.page_not_found_title}</h1>
			<p>{strings.page_not_found_text}</p>
		</IonText>
	</Page>
)

export default Page404
